import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Chart } from 'chart.js';
import { BulletPoint, CategoryPraise } from '../models/userSummaryData';
import { UniqueValues } from 'src/app/shared/helper/arrayHelper';

@Component({
    selector: 'ai-tags-summary-chart',
    templateUrl: './ai-tags-summary-chart.component.html',
    styleUrls: ['./ai-tags-summary-chart.component.scss'],
})
export class AiTagsSummaryChartComponent implements OnInit, AfterViewInit {
    @Input() public isExportMode: boolean = false;
    @Input() public startPage: number = 1;
    @Input() set aiBulletPointsData(value: BulletPoint[]) {
        if(!value || value.length == 0) return;
        this.aiBulletPoints = [...value];
        
        this.bulletPointsToAiTagsSummaryChartData([...value]);
        
    }

    public chartLabels: string[][] = [];
    public chartStrengthsData: number[] = [];
    public chartWeaknessesData: number[] = [];
    public aiBulletPoints:BulletPoint[];
    public chartId: string = 'ai-tags-summary-chart' + Math.random().toString(36).substring(7);
    public selectedTag?: string = undefined;
    public selectedBulledPoints: BulletPoint[] = [];
    public groupedBulledPoints: BulletPoint[][] = [];
    public labelsPageCount: number = 1;//minimum 1 page
    //labelPage
    //Example: label 1-2 page 0, label 3-4 page 1, label 5-6 page 2, label 7-8 page 3, label 9-10 page 4
    // [0, 0, 1, 1, 2, 2, 3, 3, 4, 4]
    public labelPageNumber:number[] = [];

    private chart: Chart;
    public chartLabelsRaw: string[] = [];
    private maxCharsInLine: number = 33;

    constructor() {
        this.chartStrengthsData = [];
        this.chartWeaknessesData = [];
     }

    ngOnInit() {}

    ngAfterViewInit() {
        
        setTimeout(async () => {
            await this._createChart();
        }, 100);
    }
    private detectWindowWidth() {
        console.log('detectWindowWidth');
        
        const width = window.innerWidth;
        if (width <= 1024) {
            this.maxCharsInLine = 24;
        }else if(width <= 768){
            this.maxCharsInLine = 15;
        }
    }

    private bulletPointsToAiTagsSummaryChartData(aiBulletPoints: BulletPoint[]) {
        console.log('bulletPointsToAiTagsSummaryChartData',"Is Export Mode: ", this.isExportMode); 
               
        this.chartLabelsRaw = UniqueValues(aiBulletPoints.map((data) => data.category_culture));

        this.groupedBulledPoints = this.chartLabelsRaw.map(p => {
            return aiBulletPoints.filter(p2 => p2.category_culture == p);
        })
        this.detectWindowWidth();
        this.handleLongLabels();


        let currentPage = 0;
        let currentTagCount = 0;
        for (let index = 0; index < this.chartLabelsRaw.length; index++) {
            const label = this.chartLabelsRaw[index];
            const strengthsCount = aiBulletPoints.filter((data) => data.category_culture == label && data.category_praise == CategoryPraise.Elogio).length;
            const weaknessesCount = aiBulletPoints.filter((data) => data.category_culture == label && data.category_praise == CategoryPraise.Critica).length;
            this.chartStrengthsData.push(strengthsCount);
            this.chartWeaknessesData.push((weaknessesCount * -1));//negative value for weaknesses

            //grouping labels by page
            this.labelPageNumber.push(currentPage);
            currentTagCount += strengthsCount + weaknessesCount;
            const hasNextLabel = index + 1 < this.chartLabelsRaw.length;
            let nextTagCount = 0;
            if(hasNextLabel){
                nextTagCount = aiBulletPoints.filter((data) => data.category_culture == this.chartLabelsRaw[index + 1]).length;
            }
            //Bellow 5 tags count we not add page number
            if(currentTagCount > 9 || !hasNextLabel || currentTagCount + nextTagCount > 11){
                currentPage++;
                currentTagCount = 0;
            }
        }
        
        this.labelsPageCount = currentPage;
        console.log('labelsPageCount', this.labelsPageCount);
        console.log("this.labelPageNumber", this.labelPageNumber);
        
        

        if(this.chart){
            console.log('Updating chart');
            
            this.chart.data.labels = this.chartLabels;
            this.chart.data.datasets[0].data = this.chartStrengthsData;
            this.chart.data.datasets[1].data = this.chartWeaknessesData;
            
            this.chart.update();
        }
    }

    public getCurrentPageNumber(index: number): number{
        return this.labelPageNumber[index];
    }

    private handleLongLabels(){
        console.log('handleLongLabels');
        
        //If a label is an array as opposed to a string i.e. [["June","2015"], "July"] then each element is treated as a seperate line.
        //https://www.chartjs.org/docs/latest/general/fonts.html#multi-line-text
        const maxCharsInLine = this.maxCharsInLine;
        
        const labels = this.chartLabelsRaw;
        const labelsWithNewLines = labels.map(label => {
            if(label.length > maxCharsInLine){
                let words = label.split(' ');
                let splitedBySlash = false;
                if(words.length == 1){
                    //if the label has no spaces, we split it by slash "/"
                    words = label.split('/');
                    splitedBySlash = true;
                }
                let currentLine = '';
                let newLabel:string[] = [];
                for (const word of words) {
                    if(currentLine.length + word.length > maxCharsInLine){
                        newLabel.push(currentLine);
                        currentLine = '';
                    }
                    currentLine += word + (splitedBySlash? '/' : ' ');
                }
                newLabel.push(currentLine);

                //if new label has more than 2 lines, we should truncate it and add "..."
                if(newLabel.length > 2){
                    newLabel = newLabel.slice(0, 2);
                    newLabel[1] = newLabel[1].concat(newLabel.slice(2).join(splitedBySlash? '/' : ' ')).substring(0, maxCharsInLine - 4) + '...';
                }
                return newLabel;
            }
            return [label];
        });
        this.chartLabels = labelsWithNewLines;
    }

    private async _createChart() {
        console.log('Creating chart');
        const labels = this.chartLabels;
        //https://github.com/chartjs/Chart.js/blob/v2.8.0/samples/charts/bar/stacked-group.html
        var horizontalBarChartData = {
            labels: labels,
            datasets: [{
                label: 'strengths',
                backgroundColor: "#4462A5",
                borderColor: "#4462A5",
                borderWidth: 1,
                data: this.chartStrengthsData
            }, {
                label: 'weaknesses',
                backgroundColor: "#707070",
                borderColor: "#707070",
                borderWidth: 1,
                data: this.chartWeaknessesData
            }]

        };

        const options: Chart.ChartOptions = {
            title: {
                display: false,
                text: 'Chart.js Bar Chart - Stacked'
            },
            tooltips: {
                enabled: false,
                mode: 'index',
                intersect: false
            },
            legend: {
                "display": false,
                position: 'bottom',
            },
            responsive: true,
            maintainAspectRatio: false,
            "hover": {
                "animationDuration": 0
            },
            "animation": {
                "duration": 0,
                "onComplete": function () {
                    const chartInstance = this.chart, ctx = chartInstance.ctx;

                    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'center';
                    const fontColor = '#FFF';
                    ctx.fillStyle = fontColor;

                    this.data.datasets.forEach(function (dataset, i) {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        meta.data.forEach(function (bar, index) {
                            var data = Number(dataset.data[index]);
                            const xAxisOffset = 10;
                            const xAxisPosition = bar._model.x + (data < 0 ? xAxisOffset : -xAxisOffset);

                            const yAxisPosition = bar._model.y + 5;
                            const dataAbs = Math.abs(data);
                            if(dataAbs == 0) return;

                            ctx.fillText(dataAbs, xAxisPosition, yAxisPosition);
                        });
                    });
                }
            },

            scales: {
                xAxes: [{
                    stacked: true,
                    gridLines: {
                        display: false
                    },
                    ticks: {
                        display: false //this will remove only the label ranges
                    }
                }],
                yAxes: [
                    <any>{
                    stacked: true,
                    // barThickness: 25,
                    gridLines: {
                        display: false,
                        
                    }
                }]
            }
        }

        const context = document.getElementById(this.chartId) as any as HTMLCanvasElement;

        //https://www.chartjs.org/docs/2.8.0/charts/bar.html
        var chart = new Chart(context, {
            type: 'horizontalBar',
            data: horizontalBarChartData,
            options: options
        });
        this.chart = chart;
        
        //https://www.chartjs.org/docs/2.8.0/developers/api.html
        context.onclick = (evt)=> {
            var firstPoint = chart.getElementAtEvent(evt)[0] as any as { _index: number, _datasetIndex: number };
            if (firstPoint) {
                // var label = chart.data.labels[firstPoint._index] as string;
                var labelRaw = this.chartLabelsRaw[firstPoint._index];
                // var value = chart.data.datasets[firstPoint._datasetIndex].data[firstPoint._index] as number;
                // var datasetName = chart.data.datasets[firstPoint._datasetIndex].label;
                this.selectedTag = labelRaw;
                this.selectedBulledPoints = this.aiBulletPoints.filter(p => p.category_culture == labelRaw);
            }

        };
    }
}
